import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "QuestionSubmitView" }
const _hoisted_2 = { class: "docArea" }
const _hoisted_3 = { class: "docArea" }

import { onMounted, ref } from "vue";
import {
  QuestionSubmitControllerService,
  QuestionSubmitVO,
} from "../../generated";
import MdViewer from "@/components/MdViewer.vue";
import message from "@arco-design/web-vue/es/message";
import moment from "moment";
import { useRouter } from "vue-router";

interface Props {
  id: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ViewQuestionSubmitView',
  props: {
    id: { default: () => "" }
  },
  setup(__props: any) {

const statusDict = {
  0: "等待判题中",
  1: "判题中",
  2: "成功",
  3: "失败",
};
const questionSubmit = ref<QuestionSubmitVO>();
const code = ref<string>();
const question = ref<string>();

const props = __props;
const loadData = async () => {
  //拿到当前题目
  const res =
    await QuestionSubmitControllerService.getQuestionSubmitVoByIdUsingGet(
      props.id as any
    );
  if (res.code === 0) {
    questionSubmit.value = res.data;
    code.value = `# 代码\n\`\`\`${questionSubmit.value?.language}\n${questionSubmit.value?.code}\n\`\`\``;
    question.value = questionSubmit.value?.questionVO?.content;
  } else {
    message.error("加载失败！ " + res.message);
  }
};
onMounted(() => {
  loadData();
});

//跳转
const router = useRouter();
const toQuestion = (id: string) => {
  router.push({
    path: `/view/question/${id}`,
  });
};
const toUser = (id: string) => {
  router.push({
    path: `/center/${id}`,
  });
};

return (_ctx: any,_cache: any) => {
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_descriptions_item = _resolveComponent("a-descriptions-item")!
  const _component_a_descriptions = _resolveComponent("a-descriptions")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("h1", null, "提交记录详情", -1)),
    _createVNode(_component_a_descriptions, {
      column: { xs: 2, md: 4, lg: 6 },
      title: "题目限制"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_descriptions_item, { label: "时间限制" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_tag, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(questionSubmit.value?.questionVO.judgeConfig.timeLimit) + " ms", 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_descriptions_item, { label: "内存限制" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_tag, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(questionSubmit.value?.questionVO.judgeConfig.memoryLimit) + " KB ", 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_descriptions_item, { label: "堆栈限制" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_tag, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(questionSubmit.value?.questionVO.judgeConfig.stackLimit) + " KB ", 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_descriptions_item, { label: "判题结果" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_tag, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(questionSubmit.value?.judgeInfo.message ?? "None."), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_descriptions_item, { label: "代码耗时" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_tag, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(questionSubmit.value?.judgeInfo.time) + " ms", 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_descriptions_item, { label: "代码占用" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_tag, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(questionSubmit.value?.judgeInfo.memory) + " KB", 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_descriptions, {
      column: { xs: 2, md: 4, lg: 6 },
      title: "当前提交"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_descriptions_item, { label: "记录ID" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_tag, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(questionSubmit.value?.questionSubmitId), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_descriptions_item, { label: "题目" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_tag, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (toQuestion(questionSubmit.value?.questionId)))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(questionSubmit.value?.questionVO.title), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_descriptions_item, { label: "提交者" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_tag, {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (toUser(questionSubmit.value?.userId)))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(questionSubmit.value?.userVO.userName), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_descriptions_item, { label: "状态" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_tag, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(statusDict[questionSubmit.value?.status]), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_descriptions_item, { label: "提交时间" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_tag, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(moment)(questionSubmit.value?.createTime).format("YYYY-MM-DD-HH:MM:SS")), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_row, { gutter: [24, 24] }, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, {
          md: 12,
          xs: 24
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(MdViewer, { value: question.value }, null, 8, ["value"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, {
          md: 12,
          xs: 24
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(MdViewer, { value: code.value }, null, 8, ["value"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})